import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SidebarPrice.css';

interface ISidebarPriceProps {
  price: string;
  discount?: React.ReactElement | null;
}

export const SidebarPrice = ({ price, discount }: ISidebarPriceProps) => {
  return (
    <div className={styles['price']}>
      <UIHeading1>{price}</UIHeading1>
      {discount && <div className={styles['discount']}>{discount}</div>}
    </div>
  );
};
